import cn from 'classnames';

import { getEnumStringValue, ListItemImage_SizeMap } from 'js/utils/enum-string-maps';

import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';

import { IListItemImage, ListItemImage_Size } from 'source/NFR.types';

const ListItemImage: React.FC<IListItemImage> = ({ image, size = ListItemImage_Size.None }) => {
  const isSmall = size === ListItemImage_Size.SmallImage;
  const sizeConfig = isSmall ? imageSizes.listItemImageSmall : imageSizes.listItemImage;

  return (
    <div className={cn('list-item-image', getEnumStringValue(ListItemImage_SizeMap, size))}>
      <div className="list-item-image__rectangle">
        <Image {...sizeConfig} {...image} />
      </div>
    </div>
  );
};

ListItemImage.displayName = 'ListItemImage';

export default ListItemImage;
